const _reqByAuth = require("./reqByAuth");
const _this = window;
_this.authReq = new _reqByAuth.default();

function encodeParams(params) {
  return Object.keys(params).map((key) => {
    return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
  }).join("&");
}

export async function callService(endpoint, json = true) {
  let response = { error: "" };
  try {
    response = await _this.authReq.httpreq(endpoint);
  } catch (error) {
    return { error };
  }
  try {
    // only proceed once promise is resolved
    let data;
    if (json) {
      data = await response.data;
      if (!response.response.ok) {
        return { response : response.response, error: data };
      }
    } else {
      data = response.data;
    }
    return { response: data };
  } catch (error) {
    return { error };
  }
}
export async function callServiceEmail(endpoint, json = true) {
  let response = { error: "" };
  try {
    response = await _this.authReq.httpreqEmail(endpoint);
  } catch (error) {
    return { error };
  }
  try {
    // only proceed once promise is resolved
    let data;
    if (json) {
      data = await response.data;
      if (!response.response.ok) {
        return { response : response.response, error: data };
      }
    } else {
      data = response.data;
    }
    return { response: data };
  } catch (error) {
    return { error };
  }
}

export async function callServiceFile(endpoint) {
  let response = { error: "" };
  try {
    response = await _this.authReq.httpreqFile(endpoint);
  } catch (error) {
    return { error };
  }
  try {
    // only proceed once promise is resolved
    let data = await response.data;
	if(response.status !== 200){
	return { response: false, error : response };	
	}
    return { response: data, error : false };
  } catch (error) {
    return { error };
  }
}

export async function callAuthService(endpoint, json = true) {
  let response = { error: "" };
  try {
    response = endpoint.payload ? await fetch(
      endpoint.url, {
        method: endpoint.type,
        headers: {
          "Authorization": endpoint.authorization,
          ...endpoint.headers
        },
        credentials: "same-origin",
        body: encodeParams(endpoint.payload)
      }) : await fetch(
      endpoint.url, {
        method: endpoint.type,
        headers: {
          "Authorization": endpoint.authorization,
          ...endpoint.headers
        },
        credentials: "same-origin"
      });
  } catch (error) {
    return { error };
  }
  try {
    // only proceed once promise is resolved
    let data;
    if (json) {
      data = await response.json();
      if (!response.ok) {
        return { response, error: data };
      }
      _this.authReq.authenticate({ refreshToken: data.refresh_token, accessToken: data.access_token, user : data.user, lastLogin : data.lastLogin, authorities : data.authorities[0]});
    } else {
      data = response;
    }
    return { response: data };
  } catch (error) {
    return { error };
  }
}
